import { IconProps } from "../../utils/global-types/global-types";

const AccessibilityIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <g fill="currentColor" clipPath="url(#clip0_2117_31408)">
        <path d="M9 3.938a1.97 1.97 0 0 0 1.969-1.97 1.97 1.97 0 0 0-3.938 0A1.97 1.97 0 0 0 9 3.939"></path>
        <path d="m15.188 3.966-.018.003-.014.004-.106.031c-.653.194-3.828 1.087-6.067 1.087-2.078 0-4.968-.774-5.893-1.037a3 3 0 0 0-.28-.092c-.669-.176-1.126.503-1.126 1.122 0 .615.552.907 1.108 1.118v.01l3.346 1.044c.341.13.433.264.479.38.144.373.028 1.11-.011 1.368l-.204 1.582-1.128 6.198-.011.052-.007.046C5.176 17.448 5.59 18 6.381 18c.689 0 .995-.475 1.125-1.122 0 0 .984-5.54 1.477-5.54.492 0 1.504 5.54 1.504 5.54.134.647.436 1.122 1.125 1.122.791 0 1.21-.552 1.125-1.122-.007-.049-.017-.094-.028-.144l-1.142-6.141-.204-1.582c-.148-.922-.028-1.227.01-1.298 0 0 .004-.003.004-.007.038-.07.21-.228.615-.38l3.14-1.096a.4.4 0 0 0 .056-.018c.562-.21 1.125-.503 1.125-1.121 0-.62-.457-1.301-1.125-1.125"></path>
      </g>
      <defs>
        <clipPath id="clip0_2117_31408">
          <path fill="#fff" d="M0 0h18v18H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default AccessibilityIcon;
